import { connect } from 'react-redux'
import SliderWrapper from '../utils/SliderWrapper'
import { getElectrician } from '../../actions'
import { useEffect } from 'react'


const ElectricicianSlider = (props) => {
    // const [loading, setLoading] = useState(true)
    const { id, slug } = props.electrician;
    const { getElectrician, mobileNav } = props
    useEffect(() => {
        if (id && slug){
            getElectrician(id, slug)
        }
    }, [id, slug, getElectrician])

    // return <SliderWrapper height={mobileNav ? '160px' : '180px'} heading="Electrician Services" to={`/services/${slug}`} sliderItemData={props.eL} mobileNav={mobileNav} extraInnerWidth={70} loading={loading} setLoading={setLoading}/>
    return <div className="slider-main__container"><SliderWrapper height={mobileNav ? '148px' : '180px'} heading="Electrician Services" to={`/services/${slug}`} sliderItemData={props.eL} mobileNav={mobileNav} extraInnerWidth={70}/></div>
}   
const mapStateToProps = (state) => {
    let electrician = {}
    if (!state.EmployeeCategory.loading){
        state.EmployeeCategory.data.forEach(element => {
            if (element.id === 1){
                electrician.id = element.id
                electrician.slug = element.slug
            }
        });
    }
    const eL = state.eL.data.filter(x => x.id !== 4)
    return {
        mobileNav: state.mobileNav,
        electrician: electrician,
        eL : eL
    }
}
export default connect(mapStateToProps , { getElectrician })(ElectricicianSlider);